import React from "react";
import { FiCheck } from "react-icons/fi";

/** Numbered progress. Completed steps can be clicked to go back; later ones cannot be jumped to. */
export default function Stepper({ steps, current, onSelect }) {
  return (
    <ol className="reg-stepper" aria-label="Sign-up progress">
      {steps.map((s, i) => {
        const n = i + 1;
        const state = n < current ? "done" : n === current ? "current" : "todo";
        return (
          <li key={s.key} className={`reg-step is-${state}`} aria-current={state === "current" ? "step" : undefined}>
            <button type="button" className="reg-step-btn" disabled={state !== "done"} onClick={() => onSelect(n)}>
              <span className="reg-step-dot">{state === "done" ? <FiCheck /> : n}</span>
              <span className="reg-step-label">{s.label}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
